import React, { useMemo } from 'react';
import { Bubble } from 'tea-component'; 
import { useIntl } from 'umi';
import { getMonitorSource } from '@op/components/TableCommonHook/utils';
import { NO_DATE } from '@op/constants';
import './index.scss';

type GameStoreMonitoringItemType = {
  name: string;
  source: 'keyword' | 'game_store';
  type: string;
  url: string;
};

export default function GameStoreMonitoringShow({
  monitor_source,
  className,
}: {
  monitor_source: Array<GameStoreMonitoringItemType>;
  className?: string;
}) {
  const { formatMessage } = useIntl();
  const { gameStore, keyword, renderList } = useMemo(() => {
    const gameStore: string[] = [];
    const keyword: string[] = [];
    (monitor_source || []).forEach((item) => {
      const info = getMonitorSource(item);
      if (info) {
        const isKeyword = item.source === 'keyword';
        const list = isKeyword ? keyword : gameStore;
        list.push(
          isKeyword ? info : formatMessage({ id: info || NO_DATE.EMPTY }),
        );
      }
    }); 

    return { gameStore, keyword, renderList: [...gameStore, ...keyword] };
  }, [monitor_source, formatMessage]);

  if (!monitor_source || !Array.isArray(monitor_source)) {
    return '-';
  }

  const getBubbleContent = () => {
    const ele = [];
    if (keyword.length > 0) {
      ele.push(<p key="by Keyword">{formatMessage({ id: 'by Keyword' })}</p>);
      ele.push(
        <p key="Keyword-Info" className="dbo-bubble-line-keyword">
          {keyword.join(", ")}
        </p>
      );
    }

    ele.push(<br />);

    if (gameStore.length > 0) {
      ele.push(<p key="by Game Store">{formatMessage({ id: 'by Game Store' })}</p>);
      ele.push(
        <p key="Account-Info">
          {gameStore.join(", ")} 
        </p>
      );
    }

    return keyword.length === 0 && gameStore.length === 0 ? null : ele;
  };

  return (
    <Bubble
      dark
      closeOnScroll
      content={getBubbleContent()}
      overlayClassName="dbo-monitoring-show"
    >
      <span className={`monitoring-show-wrapper ${className}`}>
        {renderList.join(", ")}
      </span>
    </Bubble>
  );
}
